<template>
    <div class="container">
        <div class="max-w-md">
            <el-card class="bg-white">
                <el-form ref="loginForm" :rules="loginRules" :model="loginForm" class="elform">
                    <el-form-item label class="elitem" prop="username">
                        <div class="inputcontain">
                            <img class="user" :src="icon5" />
                            <el-input
                                class="elinput"
                                v-model.trim="loginForm.username"
                                placeholder="请输入学工号/账号/电子邮箱/手机号"
                                clearable
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label class="elitem elitem2" prop="password">
                        <div class="inputcontain">
                            <img class="user" :src="icon3" />
                            <el-input
                                class="elinput"
                                v-model.trim="loginForm.password"
                                placeholder="请输入密码"
                                show-password
                                clearable
                            ></el-input>
                        </div>
                    </el-form-item>
                </el-form>
                <el-button class="btn-login" type="primary" @click="handleSide">登录</el-button>
            </el-card>
        </div>
    </div>
</template>

<script>
import { login } from "@/api/login"
export default {
    name: "side",
    data() {
        const validatePassword = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error("请输入正确的登录密码"))
            } else {
                callback()
            }
        }
        return {
            loginRules: {
                username: [{ required: true, message: "请输入账号", trigger: "blur" }],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { required: true, trigger: "blur", validator: validatePassword },
                ],
            },
            loginForm: {
                username: "", // 手机号格式
                password: "",
            },
            icon3: require("@/assets/登录/密码.png"),
            icon5: require("@/assets/登录/用户.png"),
            code_key: '',
            login_channel: '',//跳转方式，0:站内，1：第三方
        }
    },
    created() {
        this.code_key = this.$route.query.code_key;
        this.login_channel = this.$route.query.login_channel;
        console.log("新加登录页",this.$route.query)
    },
    methods: {
        // 登录
        handleSide () {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    let params = {
                        mobile: this.loginForm.username,
                        password: this.loginForm.password,
                        is_scan_code: 1,//是否扫码登录，日:否，1:是
                    }
                    login(params).then((response) => {
                        if (response.code === 0) {
                            this.$message.success(`登录成功`)
                            this.$router.push({
                                path: "/scanFace/success",
                                query: {
                                    code_key: this.code_key,
                                    // login_channel: this.login_channel,
                                    user_data: response.data.user_data
                                },
                            });
                        }
                    }).catch((error) => {  });
                } else {
                    return false
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background: #eff6ff;
    justify-content: center;
    flex-direction: column;

    .max-w-md {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
    }

    .elform {
      .elitem {
        margin-top: 30px;
        // display: flex;
        // justify-content: center;
        // align-items: center;

        .inputcontain {
          width: 95%;
          height: 45px;
          border: 1px solid #26b5ff;
          border-radius: 10px;
          padding: 0px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 0 auto;

          .user {
            margin-left: 20px;

            width: 20px;
            height: 20px;
          }

          .elinput {
            ::v-deep .el-input__inner {
              border: none;
            }
          }
        }
      }
      .elitem2 {
        margin-top: 31px;
      }
    }
    .btn-login{
        width: 100%;
    }
}

/* 自定义样式 */
::v-deep .el-card__body {
    text-align: center;
}

.el-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.el-button {
    border-radius: 12px;
    padding: 12px 0;
    font-size: 16px;
}
</style>